import { deleteApi } from "./api_instance";

export const deleteRegistry = async (id, registryID, logout) => {
  try {
    const data = await deleteApi({
      apiUrl: `/projects/api/registry/${id}`,
      sendToken: true,
      data: {registryID},
      logout,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
